// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ChatMessage,
} from "./types";

export const params = {
  startMicros: __t.i64(),
  endMicros: __t.i64(),
  sender: __t.option(__t.identity()),
  limit: __t.u32(),
};
export const returnType = __t.array(ChatMessage)